import React, { ChangeEvent, FormEvent, useEffect, useState } from 'react';

import { useLogin } from '../../hooks/sessions';

import { CookiesHelper } from '../../helpers/cookies.helper';
import { AuthHelper } from '../../helpers/auth.helper';

import { TextInput } from '../shared/Inputs';

export const LoginWrapper = () => {

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [active, setActive] = useState(false);

    const { mutate: login } = useLogin();

    useEffect(() => {
        const authTokenValidationRes = AuthHelper.isAuthTokenValid();
        const sessionTokenValidationRes = AuthHelper.isSessionTokenValid();

        if (
            !window.location.origin.startsWith(`http://localhost`) &&
            (!authTokenValidationRes.result || !sessionTokenValidationRes.result)
        ) {
            setActive(true);
        } else {
            setActive(false);
        };

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [AuthHelper.isAuthTokenValid(), AuthHelper.isSessionTokenValid()]);

    const onChangeInput = (e: ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;

        setError('');

        if (name === 'username') {
            setUsername(value);
        } else if (name === 'password') {
            setPassword(value);
        };
    };

    const onSubmit = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (isLoading) return;

        if (!username || !password) {
            setError('Please enter a valid username and password');
            return;
        };

        const sessionToken = CookiesHelper.get(`${process.env.REACT_APP__SESSION_TOKEN_NAME}`);

        login({
            payload: {
                username,
                password,
                sessionToken,
            },
            setIsLoading,
            setError,
        });
    };

    return (
        <div className={`login_wrapper ${active ? 'login_wrapper--active' : ''}`}>
            <div className='card card--md login_wrapper__content'>
                <h4 className='color--primary mb-xl'>Please login to continue</h4>
                <form onSubmit={onSubmit}>
                    <div className='mb-lg'>
                        <label htmlFor="username">
                            <p className="text-md text-medium pb-xs">Username</p>
                        </label>
                        <TextInput
                            type="text"
                            id="username"
                            name="username"
                            placeholder="Your Username"
                            onChange={onChangeInput}
                            value={username}
                        />
                    </div>
                    <div className='mb-lg'>
                        <label htmlFor="password">
                            <p className="text-md text-medium pb-xs">Password</p>
                        </label>
                        <TextInput
                            type="password"
                            id="password"
                            name="password"
                            placeholder="Your Password"
                            onChange={onChangeInput}
                            value={password}
                        />
                    </div>
                    <button
                        type="submit"
                        className='btn btn--fluid btn--lg btn--primary'
                        disabled={!username || !password}
                    >
                        Continue
                    </button>
                    {error && <p className='text-sm text-medium color--error text-center mt-xs'>{error}</p>}
                </form>
            </div>
        </div>
    );
};